import script from "./AgendorBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgendorBadge.vue?vue&type=script&setup=true&lang=ts"

import "./AgendorBadge.vue?vue&type=style&index=0&id=70d653c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d653c6"]])

export default __exports__